// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class LogonMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_LOGON_MESSAGE, fieldSet);
    }
    // +++ new
    getLogin() {
        return this.getFieldValue(FieldsFactory.FIELD_LOGIN);
    }
    // +++ new
    setLogin(login) {
        this.setFieldValue(FieldsFactory.FIELD_LOGIN, login);
    }
    // +++ new
    getPassword() {
        return this.getFieldValue(FieldsFactory.FIELD_PASSWORD);
    }
    // +++ new
    setPassword(password) {
        this.setFieldValue(FieldsFactory.FIELD_PASSWORD, password);
    }
    // +++ new
    getConnectionMode() {
        return this.getFieldValue(FieldsFactory.FIELD_CONNECTION_MODE);
    }
    // +++ new
    setConnectionMode(mode) {
        this.setFieldValue(FieldsFactory.FIELD_CONNECTION_MODE, mode);
    }
    // +++ new
    getClientType() {
        return this.getFieldValue(FieldsFactory.FIELD_CLIENT_TYPE);
    }
    // +++ new
    setClientType(ctype) {
        this.setFieldValue(FieldsFactory.FIELD_CLIENT_TYPE, ctype);
    }
    // +++ new
    getVerificationPassword() {
        return this.getFieldValue(FieldsFactory.FIELD_VERIFICATION_PASSWORD);
    }
    // +++ new
    setVerificationPassword(verificationPassword) {
        this.setFieldValue(FieldsFactory.FIELD_VERIFICATION_PASSWORD, verificationPassword);
    }
    // +++ new
    getProtocolVersion() {
        return this.getFieldValue(FieldsFactory.FIELD_PROTOCOL_ID);
    }
    // +++ new
    setProtocolVersion(version) {
        this.setFieldValue(FieldsFactory.FIELD_PROTOCOL_ID, version);
    }
    // +++ new
    getMaxFieldNumber() {
        const FIELD_MAX_PFIX_FIELD_INDEX = this.FieldSet.GetField(FieldsFactory.FIELD_MAX_PFIX_FIELD_INDEX);
        if (FIELD_MAX_PFIX_FIELD_INDEX) {
            return FIELD_MAX_PFIX_FIELD_INDEX.Value;
        }
        else {
            return 2147483647;
        } // int.MaxValue;
    }
    // +++ new
    setMaxFieldNumber(number) {
        this.setFieldValue(FieldsFactory.FIELD_MAX_PFIX_FIELD_INDEX, number);
    }
    // +++ new
    getCanISendGetInitDataRequest() {
        return this.getFieldValue(FieldsFactory.FIELD_NONE) === 1;
    }
    // +++ new
    setCanISendGetInitDataRequest(value) {
        this.setFieldValue(FieldsFactory.FIELD_NONE, value ? 1 : 0);
    }
    // +++ new
    getIsUnfixedList() {
        return this.getFieldValue(FieldsFactory.FIELD_IS_UNFIXED_LIST);
    }
    setDateOfBuild(value) {
        this.setFieldValue(FieldsFactory.FIELD_DATE_OF_BUILD, value);
    }
    getSessionId() {
        return this.getFieldValue(FieldsFactory.FIELD_SESSIONID);
    }
    getTradingUnlockLogic() {
        return this.getFieldValue(FieldsFactory.FIELD_TRADING_UNLOCK_LOGIC);
    }
    getVerificationMode() {
        return this.getFieldValue(FieldsFactory.FIELD_2FA_TYPE);
    }
    getNeedVerificationPassword() {
        return this.getFieldValue(FieldsFactory.FIELD_NEED_VERIFICATION_PWD);
    }
    setExternalResourse(extResId) {
        this.setFieldValue(FieldsFactory.FIELD_EXT_RESOURCE, extResId);
    }
    setTokenID(tokenID) {
        this.setFieldValue(FieldsFactory.FIELD_TOKEN_ID, tokenID);
    }
    isPasswordExpired() {
        return this.getFieldValue(FieldsFactory.FIELD_PWD_EXPIRED);
    }
    // version 1.9
    // +++ new
    setAccessToken(accessToken) {
        this.setFieldValue(FieldsFactory.FIELD_ACCESS_TOKEN, accessToken);
    }
    // +++ new
    GetAccessToken() {
        return this.getFieldValue(FieldsFactory.FIELD_ACCESS_TOKEN);
    }
    // +++ new
    GetAccessTokenLifeTime() {
        return this.getFieldValue(FieldsFactory.FIELD_ACCESS_TOKEN_LIFE_TIME);
    }
    // +++ new
    GetRefreshToken() {
        return this.getFieldValue(FieldsFactory.FIELD_REFRESH_TOKEN);
    }
    // +++ new
    GetRefreshTokenLifeTime() {
        return this.getFieldValue(FieldsFactory.FIELD_REFRESH_TOKEN_LIFE_TIME);
    }
    // brandingKey
    setBrandingKey(brandingKey) {
        this.setFieldValue(FieldsFactory.FIELD_BRANDING_KEY, brandingKey);
    }
    SetCustomerNo(customerNo) {
        this.setFieldValue(FieldsFactory.FIELD_EXTERNAL_ACCOUNT, customerNo);
    }
    // IP
    setIP(IP) {
        this.setFieldValue(FieldsFactory.FIELD_SOURCE, IP);
    }
    // https://tp.traderevolution.com/entity/113979
    SetAppInstallId(appInstallId) {
        this.setFieldValue(FieldsFactory.FIELD_APP_INSTALL_ID, appInstallId);
    }
}
